<template>
    <div>
        <CollectionActionBar class="d-print-none" @saveClicked="onSaveClicked" @newClicked="onNewClicked"
            @loadClicked="onLoadClicked" @printClicked="onPrintClicked" @nextClicked="onNextClicked"
            @prevClicked="onPrevClicked" @overrideClicked="onAdminOverrideClicked" @excludeClicked="onExcludeClicked"
            @deleteClicked="onDeleteClicked" @exportClicked="onExportClicked" />
        <TabsWrapper class="d-print-none" :selected-tab="selectedTab" @headerClicked="tabHeaderClicked">
            <Tab title="Entry" icon="bi bi-clipboard-data">
                <MediumSizedModal :show="showModal" :title="title" @close="toggleModal">
                    <TaxDecPicker ref="tdPickerRef" @item-selected="onTaxDecSelected" v-if="mode === 'taxdec'" />
                    <AfterSaveDialog v-else-if="mode === 'aftersave'" ref="afterSaveDialog"
                        @selected="handleAfterSave" />
                    <ConcessionairePicker v-else-if="mode === 'concessionaire'" :typedName="typedName"
                        @cancel="toggleModal" @concessionaire-added="onConcessionaireAdded" />
                </MediumSizedModal>
                <div class="row">
                    <div class="form-group col-lg-3">
                        <label>Bonded Cashier</label>
                        <select @change="checkChange" class="form-select"
                            v-model="loadedTransaction.transaction_Header.sysFK_InCharge_TransH">
                            <option :value="emp.value" v-for="emp in employeeOptions" :key="emp.value">{{ emp.label }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group col-lg-3">
                        <label>Booklet #</label>
                        <ComboboxView ref="cbBooklet" :cancreateitem="false" @item-selected="onBookletSelected"
                            :api-url="`logbook/gen/search/0/${loadedTransaction.transaction_Header.sysFK_InCharge_TransH}`" />
                    </div>
                    <div class="from-group col-lg-2">
                        <label for="iorno">OR #:</label>
                        <input v-model="loadedTransaction.transaction_Header.userPK_TransH" type="text"
                            class="form-control text-end" id="iorno" />
                    </div>
                    <div class="from-group col-lg-2">
                        <label for="idate">Date:</label>
                        <input v-model="dateIssueFormatted" type="date" class="form-control text-end" id="idate" />
                    </div>
                    <!-- Payment Type Radio Buttons -->
                    <div class="form-group col-lg-2">
                        <div class="btn-group mt-4" role="group" aria-label="Payment type">
                            <!-- Cash (default selected) -->
                            <input type="radio" class="btn-check" name="paymentType" id="cash" autocomplete="off"
                                v-model="loadedTransaction.transaction_Header.payType_TransH" value="Cash">
                            <label class="btn btn-sm btn-outline-primary" for="cash">
                                <i class="bi bi-cash-coin me-1"></i> Cash
                            </label>

                            <!-- Check -->
                            <input type="radio" class="btn-check" name="paymentType" id="check" autocomplete="off"
                                v-model="loadedTransaction.transaction_Header.payType_TransH" value="Check">
                            <label class="btn btn-sm btn-outline-primary" for="check">
                                <i class="bi bi-pen me-1"></i> Check
                            </label>

                            <!-- Others -->
                            <input type="radio" class="btn-check" name="paymentType" id="others" autocomplete="off"
                                v-model="loadedTransaction.transaction_Header.payType_TransH" value="Others">
                            <label class="btn btn-sm btn-outline-primary" for="others">
                                <i class="bi bi-three-dots me-1"></i> Others
                            </label>
                        </div>
                        <div class="row" v-if="loadedTransaction.transaction_Header.payType_TransH === 'Check'">
                            <div class="form-group col-lg-6">
                                <label>Cheque #</label>
                                <input class="form-control" type="text"
                                    v-model="loadedTransaction.transaction_Header.accountDocumentNum_TransH" />
                            </div>
                            <div class="form-group col-lg-6">
                                <label>Cheque Date</label>
                                <input type="date" class="form-control" v-model="chequeDateFormatted" />
                            </div>
                        </div>
                        <div class="row"
                            v-if="loadedTransaction.transaction_Header.payType_TransH?.toLowerCase() === 'others'">
                            <div class="form-group col-lg-6">
                                <label>Notes</label>
                                <input class="form-control" type="text"
                                    v-model="loadedTransaction.transaction_Header.accountCode_TransH" />
                            </div>
                            <div class="form-group col-lg-6">
                                <label>Ref #</label>
                                <input type="text" class="form-control"
                                    v-model="loadedTransaction.transaction_Header.accountDocumentNum_TransH" />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 form-group">
                        <label>Payor Name</label>
                        <ComboboxView placeholder="Enter payor name" api-url="acctmaster/search"
                            @item-selected="onPayorSelected" @item-added="onItemAdded" :cancreateitem="true"
                            ref="cbActRef" />
                    </div>
                    <div class="form-group col-lg-4">
                        <label for="selpayorname">Collection Type:</label>
                        <select class="form-select" id="selpayorname">
                            <option value="Water Billing">Water Billing</option>
                        </select>
                    </div>
                    <div class="from-group col-lg-3">
                        <label for="iamount">Amount:</label>
                        <input :value="$formatters.formatCurrency(grandTotal)" readonly="true" type="text"
                            class="form-control text-end" id="iamount" />
                    </div>
                    <div class="col-lg-1 justify-content-middle">
                        <div class="form-check form-switch mt-1">
                            <input @change="handleInlieuChange" class="form-check-input" style="cursor: pointer"
                                v-model="loadedTransaction.transaction_Header.isInLiue" type="checkbox" role="switch"
                                id="flexSwitchCheckDefault">
                            <label class="form-check-label" style="cursor: pointer" for="flexSwitchCheckDefault">In
                                Lieu</label>
                        </div>
                        <div v-show="loadedTransaction.transaction_Header.isInLiue" class="btn-group" role="group"
                            aria-label="Payment type">
                            <!-- FORM56 (default selected) -->
                            <input type="radio" class="btn-check" name="formType" id="f56" autocomplete="off"
                                v-model="loadedTransaction.transaction_Header.moduleType_TransH" value="FORM56">
                            <!-- Added FORM56 as value -->
                            <label class="btn btn-sm btn-outline-primary" for="f56">
                                <span class="badge bg-secondary">56</span>
                            </label>

                            <!-- FORM57 -->
                            <input type="radio" class="btn-check" name="formType" id="f57" autocomplete="off"
                                v-model="loadedTransaction.transaction_Header.moduleType_TransH" value="FORM57">
                            <label class="btn btn-sm btn-outline-primary" for="f57">
                                <span class="badge bg-secondary">57</span>
                            </label>

                            <!-- FORM58 -->
                            <input type="radio" class="btn-check" name="formType" id="f58" autocomplete="off"
                                v-model="loadedTransaction.transaction_Header.moduleType_TransH" value="FORM58">
                            <label class="btn btn-sm btn-outline-primary" for="f58">
                                <span class="badge bg-secondary">58</span>
                            </label>
                        </div>
                    </div>

                </div>
                <div class="col-lg-12 mb-3">
                    <label for="particularsInput" class="form-label">Particulars</label>
                    <textarea id="particularsInput" class="form-control"
                        v-model="loadedTransaction.transaction_Header.particulars_TransH" rows="3"></textarea>
                </div>
                <div class="col-lg-12 form-group">
                    <label>Items</label>
                    <ComboboxView apiUrl="pm/search/item" placeholder="Search item" ref="cbItemRef"
                        @item-selected="onItemSelected" />
                </div>
                <div class="table-responsive">
                    <table class="table table-sm" style="font-size: 0.875rem;">
                        <thead>
                            <tr>
                                <th>Revision</th>
                                <th>Collection Code</th>
                                <th>Collection Title</th>
                                <th>Paid Amount</th>
                                <th>Amount w/ hold</th>
                                <th>Net Amount <b>({{ $formatters.formatCurrency(grandTotal) }})</b></th>
                                <th>Line Explaination</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="trans in loadedTransaction.transactionEntries" :key="trans.sysPK_ColTypeEntries"
                                v-show="shouldShow(trans)">
                                <td class="d-flex justify-content-between"><span>{{ trans.userFK_Revision_ColTypeEntries
                                }}</span> <button class="btn btn-sm btn-outline-secondary"
                                        @click.stop.prevent="onChangeRPUClicked(trans)"
                                        v-if="trans.userFK_Revision_ColTypeEntries && trans.userFK_Revision_ColTypeEntries !== ''"
                                        type="button">
                                        <i class="bi bi-pencil"></i>
                                    </button></td>
                                <td>{{ trans.userPK_PM }}</td>
                                <td>{{ trans.description_PM }}</td>
                                <NumberEditableCell v-model="trans.amount_ColTypeEntries"
                                    :id="trans.sysPK_ColTypeEntries.toString()" @change="handleNumberItemChange" />
                                <td class="text-end">{{ $formatters.formatCurrency(trans.amountAdjust_ColTypeEntries) }}
                                </td>
                                <td class="text-end">{{ $formatters.formatCurrency(trans.amountNet_ColTypeEntries) }}
                                </td>
                                <td>{{ trans.userFK_GenericClass_ColTypeEntries }}</td>
                                <td>{{ trans.particulars_ColTypeEntries }}</td>
                                <td><button type="button" class="btn btn-sm btn-danger"
                                        @click="handleItemRemove(trans.sysPK_ColTypeEntries)"><i
                                            class="bi bi-trash"></i></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </Tab>
            <Tab title="Index" icon="bi bi-table">
                <div>
                    <div class="text-end pe-0 pe-md-2">
                        <PaginatorComponent :items-per-page="pagination.itemsPerPage"
                            :current-page="pagination.currentPage" :total-items="pagination.totalItems"
                            @page-changed="handlePageChange" />
                    </div>
                    <form @submit.prevent="onLoadClicked">
                        <div class="table-responsive">
                            <table class="table table-sm table-hover align-middle" style="font-size: 0.875rem;">
                                <thead>
                                    <tr>
                                        <th>Book #</th>
                                        <th>Bonded Cashier</th>
                                        <th>OR #</th>
                                        <th>Status</th>
                                        <th>Issued</th>
                                        <th>Payor</th>
                                        <th>Account</th>
                                        <th>Pay Type</th>
                                        <th>Net Amount</th>
                                        <th>OR Type</th>
                                        <th>Prepared By</th>
                                        <th>Cash Amt.</th>
                                        <th>Others Amt.</th>
                                        <th>Cheque Amt.</th>
                                        <th>Cheque #</th>
                                        <th>Cheque Date</th>
                                        <th>Module Type</th>
                                        <th>Added On</th>
                                        <th>Added By</th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <input class="form-control" v-model="searchModel.sysSeq_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.inChargedBy_TransH" />
                                            <button type="submit" class="btn btn-sm btn-secondary d-lg-none">
                                                <i class="bi bi-search"></i>
                                            </button>
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.userPK_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.status_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.dateIssue_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.nameFull_UM_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control"
                                                v-model="searchModel.nameFull_AcctMstr_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.payType_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.totalAmount_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" readonly v-model="searchModel.type_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.preparedBy_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.amount01_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.amount03_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.amount02_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control"
                                                v-model="searchModel.accountDocumentNum_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control"
                                                v-model="searchModel.dateAccountDocument_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.moduleType_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.recordAddedDate_TransH" />
                                        </th>
                                        <th>
                                            <input class="form-control" v-model="searchModel.recordAddedBy_TransH" />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="trans, index in transactions" :key="trans.sysPK_TransH"
                                        style="cursor: pointer;"
                                        :class="(trans.userFK_Branch_TransH === 'EXCLUDERDCD' && hasRoles(['admin']) ? 'bg-danger' : '')"
                                        @click.prevent="transactionClicked(trans)">
                                        <td><i v-show="selectedIndex === index"
                                                class="bi bi-arrow-right-short text-info"></i> {{
                                                    trans.sysSeq_TransH }}</td>
                                        <td>{{ trans.inChargedBy_TransH }}</td>
                                        <td>{{ trans.userPK_TransH }}</td>
                                        <td class="text-center">
                                            <span class="badge" :class="{
                                                'bg-warning': trans.status_TransH === 'UNREMITTED',
                                                'bg-primary': trans.status_TransH === 'REMITTED',
                                                'bg-success': trans.status_TransH === 'RECEIVED'
                                            }">
                                                {{ trans.status_TransH }}
                                            </span>
                                        </td>
                                        <td>{{ trans.dateIssue_TransH }}</td>
                                        <td>{{ trans.nameFull_UM_TransH?.toUpperCase() }}</td>
                                        <td>{{ trans.nameFull_AcctMstr_TransH?.toUpperCase() }}</td>
                                        <td class="text-center">
                                            <span class="badge" :class="{
                                                'bg-warning': trans.payType_TransH?.toLowerCase() === 'others',
                                                'bg-primary': trans.payType_TransH?.toLowerCase() === 'cash',
                                                'bg-success': trans.payType_TransH?.toLowerCase() === 'check'
                                            }">
                                                {{ trans.payType_TransH }}
                                            </span>
                                        </td>
                                        <td class="text-end">{{ $formatters.formatCurrency(trans.totalAmount_TransH) }}
                                        </td>
                                        <td>{{ trans.type_TransH }}</td>
                                        <td>{{ trans.preparedBy_TransH }}</td>
                                        <td class="text-end">{{ $formatters.formatCurrency(trans.amount01_TransH) }}
                                        </td>
                                        <td class="text-end">{{ $formatters.formatCurrency(trans.amount03_TransH) }}
                                        </td>
                                        <td class="text-end">{{ $formatters.formatCurrency(trans.amount02_TransH) }}
                                        </td>
                                        <td>{{ trans.accountDocumentNum_TransH }}</td>
                                        <td>{{ trans.dateAccountDocument_TransH }}</td>
                                        <td>{{ trans.moduleType_TransH }}</td>
                                        <td>{{ trans.recordAddedDate_TransH }}</td>
                                        <td>{{ trans.recordAddedBy_TransH }}</td>

                                    </tr>
                                </tbody>

                            </table>
                        </div>
                    </form>
                </div>
            </Tab>

        </TabsWrapper>
        <Form51Receipt class="d-none d-print-block" :loadedTransaction="loadedTransaction.transaction_Header"
            :selectedCollections="loadedTransaction.transactionEntries" ref="form51Ref" />
    </div>
</template>

<script setup>
import CollectionActionBar from '@/components/CollectionActionBar.vue';
import ComboboxView from '@/components/customs/ComboboxView.vue';
import Tab from '@/components/tabs/Tab.vue';
import TabsWrapper from '@/components/tabs/TabsWrapper.vue';
import spinnerService from '@/services/spinnerService';
import transactionService from '@/services/transactionService';
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import JSONbig from 'json-bigint'; // For handling big integers
import NumberEditableCell from '@/components/customs/NumberEditableCell.vue';
import { generateBigIntId } from '@/utils/generator';
import Form51Receipt from '@/components/printing/Form51Receipt.vue';
import toastService from '@/services/toastService';
import umService from '@/services/umService';
import PaginatorComponent from '@/components/customs/PaginatorComponent.vue';
import { isInRange, getBookletNextNumber } from '@/utils/rangeHelper';
import AfterSaveDialog from '@/components/dialogs/AfterSaveDialog.vue';
import MediumSizedModal from '@/components/dialogs/MediumSizedModal.vue';
import TaxDecPicker from '@/components/pickers/TaxDecPicker.vue'
import ConcessionairePicker from '@/components/pickers/ConcessionairePicker.vue';
import { hasRoles } from '@/utils/auth';
import confirmationService from '@/services/confirmationService';
import { useRouter } from 'vue-router'

const router = useRouter()
// Configure JSONbig to handle native BigInt serialization
const JSONbigString = JSONbig({
    useNativeBigInt: true,
    alwaysParseAsBig: false,
    protoAction: 'ignore',
    constructorAction: 'ignore'
});
const selectedIndex = ref(-1);
const type = 'Water Billing'
const form51Ref = ref(null);
const transactions = ref([]);
const searchModel = ref({ type_TransH: "Water Billing" });
const selectedTab = ref("Entry");
const loadedTransaction = ref({ transaction_Header: { payType_TransH: "Cash", recMarker: "new", isInLiue: false, module_TransH: "RECEIPTS", moduleType_TransH: "FORM51", type_TransH: type, dateIssue_TransH: new Date().toISOString() }, transactionEntries: [] });
const cbActRef = ref(null);
const cbBooklet = ref(null);
const cbItemRef = ref(null);
const pagination = ref({ currentPage: 1, totalItems: 0, itemsPerPage: 50 })
const afterSaveDialog = ref(null);
const showModal = ref(false);
const pageSearchModel = ref();
const selectedItem = ref(null);
const mode = ref("");
const title = ref("Save successful");
const tdPickerRef = ref(null);
const tdPickerMode = ref("new");
const typedName = ref("");
const handlePageChange = async (page) => {
    spinnerService.show();
    const response = await transactionService.search(page, pageSearchModel.value);
    pagination.value = { currentPage: page, totalItems: response.totalItems, itemsPerPage: response.itemsPerPage }
    transactions.value = response.data;
    spinnerService.hide();
}
// eslint-disable-next-line
const handleAfterSave = (option) => {
    switch (option) {
        case "create":
            onNewClicked();
            break;
        case "print":
            onPrintClicked();
            break;
    }
    toggleModal();
}

// const cbBondedRef = ref(null);
const grandTotal = computed(() => {
    const total = loadedTransaction.value.transactionEntries
        .filter(item => {
            // Explicitly check for active/valid items
            return item?.recMarker !== 'deleted' &&
                item?.recMarker !== 'DELETED' &&
                item?.amountNet_ColTypeEntries !== undefined;
        })
        .reduce((sum, item) => sum + (item.amountNet_ColTypeEntries || 0), 0);
    return total;
}
);
const searchTransactions = async () => {
    pageSearchModel.value = { ...searchModel.value };
    const response = await transactionService.search(1, searchModel.value);
    pagination.value = { currentPage: response.currentPage, totalItems: response.totalItems, itemsPerPage: response.itemsPerPage }
    transactions.value = response.data;
}



function handleItemRemove(id) {
    const index = loadedTransaction.value.transactionEntries.findIndex(x => x.sysPK_ColTypeEntries === id);
    if (index >= 0) {  // Important: findIndex returns -1 if not found
        const item = loadedTransaction.value.transactionEntries[index];
        if (item.recMarker === 'new') {
            loadedTransaction.value.transactionEntries.splice(index, 1);
        } else {
            item.recMarker = "deleted";
        }
        loadedTransaction.value.transaction_Header.totalAmount_TransH = grandTotal;
    } else {
        console.warn(`Item with id ${id} not found`);
    }
}

const isORnumberValid = computed(() =>
    isInRange(loadedTransaction.value.transaction_Header.userPK_TransH, loadedTransaction.value.booklet.refDocNumRangeFrom_ARMLogBk, loadedTransaction.value.booklet.refDocNumRangeTo_ARMLogBk)
);

const onSaveClicked = async () => {
    if (!selectedBooklet.value || selectedBooklet.value === '0' || selectedBooklet.value === 0) {
        toastService.error("Booklet required.");
        return;
    }
    if (!isORnumberValid.value) {
        toastService.error("OR number is not part of the selected booklet.");
        return;
    }

    if (loadedTransaction.value.transaction_Header.sysFK_UM_TransH === 0) {
        toastService.error("Valid payor name is required.");
        return;
    }
    if (!loadedTransaction.value.transactionEntries || loadedTransaction.value.transactionEntries.length === 0) {
        toastService.error("Please add an item to continue saving the receipt.");
        return;
    }
    spinnerService.show();
    const itemToSave = {
        transaction_Header: loadedTransaction.value.transaction_Header,
        transactionEntries: loadedTransaction.value.transactionEntries,
        booklet: loadedTransaction.value.booklet
    }
    const response = await transactionService.saveForm51(itemToSave);
    if (response.success) {
        loadedTransaction.value.transaction_Header = response.transaction_Header;
        loadedTransaction.value.transactionEntries = response.transactionEntries;
        loadedTransaction.value.booklet = response.booklet;
        cbBooklet.value.preSelectOption({
            label: response.booklet.text,
            value: response.booklet.value,
            raw: response.booklet
        });
        toastService.success("Save successful!")
        mode.value = "aftersave";
        title.value = "Save successful"
        showModal.value = true;
    }
    else {
        toastService.error(response.message);
    }
    spinnerService.hide();
}
const onNewClicked = () => {
    const lastBondedSelectedId = loadedTransaction.value.transaction_Header.sysFK_InCharge_TransH;
    const lastSelectedBondedName = loadedTransaction.value.transaction_Header.inChargedBy_TransH;
    loadedTransaction.value.transaction_Header = {
        payType_TransH: "Cash", recMarker: "new", isInLiue: false, module_TransH: "RECEIPTS",
        moduleType_TransH: "FORM51", type_TransH: type, dateIssue_TransH: new Date().toISOString(),
        sysFK_InCharge_TransH: lastBondedSelectedId, inChargedBy_TransH: lastSelectedBondedName, sysSeq_TransH: loadedTransaction.value.booklet?.sysSeq_ARMLogBk
    };
    loadedTransaction.value.transaction_Header.sysFK_BatchTransH_TransH = loadedTransaction.value.booklet?.sysPK_ARMLogBk;
    loadedTransaction.value.transactionEntries = [];
    //selectedBooklet.value = null;
    cbActRef.value.preSelectOption({
        label: null, value:
            0
    })
    if (loadedTransaction.value.booklet) {
        loadedTransaction.value.transaction_Header.userPK_TransH = getBookletNextNumber(loadedTransaction.value.booklet)
    }
    selectedTab.value = "Entry";
}
const onLoadClicked = async () => {
    selectedTab.value = "Index";
    selectedIndex.value = -1;
    spinnerService.show();
    searchModel.value.type_TransH = type;
    await searchTransactions();
    spinnerService.hide();
}
const tabHeaderClicked = (title) => {
    selectedTab.value = title;
}

const onPrintClicked = () => {
    form51Ref?.value.printReceipt();
}

const onPrevClicked = () => {
    if (transactions.value && transactions.value.length > 0 && selectedIndex.value > 0) {
        selectedIndex.value -= 1;
        const trans = transactions.value[selectedIndex.value];
        if (trans) {
            if (selectedTab.value === "Entry")
                transactionClicked(trans);
        }
        else
            selectedIndex.value += 1;
    }
}
const onNextClicked = () => {
    if (transactions.value && transactions.value.length > 0 && selectedIndex.value < transactions.value.length) {
        selectedIndex.value += 1;
        const trans = transactions.value[selectedIndex.value];
        if (trans) {
            if (selectedTab.value === "Entry")
                transactionClicked(trans);
        }
        else
            selectedIndex.value -= 1;
    }
}
const onAdminOverrideClicked = () => {
    if (hasRoles(['admin', 'can override'])) {
        alert('override')
    }
    else {
        toastService.error('Action forbidden')
    }
}
const onExcludeClicked = async () => {
    if (hasRoles(['admin', 'can exclude-rdcd'])) {
        const confirmed = await confirmationService.show("Are you sure you want to continue?");
        if (!confirmed)
            return;
        const response = await transactionService.exclude(loadedTransaction.value.transaction_Header.sysPK_TransH);
        if (response.success) {
            toastService.success("Item has been excluded");
        }
        else {
            toastService.error(response.message);
        }
    }
    else {
        toastService.error("Action forbidden");
    }
}
const onDeleteClicked = async () => {
    if (hasRoles(['admin', 'can delete'])) {
        const confirmed = await confirmationService.show("Are you sure you want to delete this receipt?");
        if (!confirmed)
            return;
        spinnerService.show();
        const response = await transactionService.delete(loadedTransaction.value.transaction_Header.sysPK_TransH);
        if (response.success) {
            onNewClicked();
            toastService.success("Item has been deleted");
        }
        else {
            toastService.error(response.message);
        }
        spinnerService.hide();
    }
    else {
        toastService.error("Action forbidden")
    }
}
const onExportClicked = async () => {
    if (hasRoles(['admin', 'can export'])) {
        alert('export')
    }
    else {
        toastService.error("Action forbidden")
    }
}
const onChangeRPUClicked = (item) => {
    tdPickerMode.value = "mod";
    selectedItem.value = { ...item };
    mode.value = "taxdec";
    title.value = "Select Tax Declaration"
    setTimeout(() => {
        tdPickerRef.value?.focusInput();
    }, 150);
    toggleModal();
}
const onTaxDecSelected = async (td) => {
    if (tdPickerMode.value === "new") {
        const newItem = {
            sysPK_ColTypeEntries: generateBigIntId().toString(),
            userPK_PM: selectedItem.value.userPK_PM,
            sysFK_PM_ColTypeEntries: selectedItem.value.sysPK_PM,
            description_PM: selectedItem.value.description_PM,
            amount_ColTypeEntries: selectedItem.value.minimumRate_PM,
            amountNet_ColTypeEntries: selectedItem.value.minimumRate_PM,
            displayQty_ColTypeEntries: 1,
            sysFK_AcctMstr_CtrctTrans: td.sysPK_AcctMstr,
            userFK_Revision_ColTypeEntries: td.userFK_Revision_AcctMstr,
            userFK_GenericClass_ColTypeEntries: td.userPK_ARP_AcctMstr,
            recMarker: 'new'
        };
        loadedTransaction.value.transactionEntries.push(newItem);
        loadedTransaction.value.transaction_Header.totalAmount_TransH = grandTotal;
    }
    else {
        const idx = loadedTransaction.value.transactionEntries.findIndex(x => x.sysPK_ColTypeEntries === selectedItem.value.sysPK_ColTypeEntries);
        if (idx > -1) {
            const item = loadedTransaction.value.transactionEntries[idx];
            if (item.recMarker === "existing")
                item.recMarker = "modified";
            item.sysFK_AcctMstr_CtrctTrans = td.sysPK_AcctMstr;
            item.userFK_Revision_ColTypeEntries = td.userFK_Revision_AcctMstr;
            item.userFK_GenericClass_ColTypeEntries = td.userPK_ARP_AcctMstr;
        }
    }
    toggleModal();
}
// eslint-disable-next-line
function onItemSelected(item) {
    if (!item || !cbItemRef.value) return;
    const itemValue = item.value;
    const isEmptyValue = itemValue === "0" || itemValue === 0 || itemValue === "";
    if (!isEmptyValue) {
        cbItemRef.value.clearSelection();
        if (item.raw.userPK_PM === 'TC' || item.raw.userPK_PM === 'TOT' || item.raw.userPK_PM === 'TF' || item.raw.userPK_PM === 'CTCTD') {
            selectedItem.value = item.raw;
            mode.value = "taxdec";
            title.value = "Select Tax Declaration";
            setTimeout(() => {
                tdPickerRef.value?.focusInput()
                tdPickerMode.value = "new";
            }, 150);

            toggleModal();
            return;
        }
        const newItem = {
            sysPK_ColTypeEntries: generateBigIntId().toString(),
            userPK_PM: item.raw.userPK_PM,
            sysFK_PM_ColTypeEntries: item.raw.sysPK_PM,
            description_PM: item.raw.description_PM,
            amount_ColTypeEntries: item.raw.minimumRate_PM,
            amountNet_ColTypeEntries: item.raw.minimumRate_PM,
            displayQty_ColTypeEntries: 1,
            recMarker: 'new'
        };
        loadedTransaction.value.transactionEntries.push(newItem);
        loadedTransaction.value.transaction_Header.totalAmount_TransH = grandTotal;
    }
}


function handleNumberItemChange(index) {
    if (index >= 0 && loadedTransaction.value?.transactionEntries) {
        const item = loadedTransaction.value.transactionEntries.find(x => x.sysPK_ColTypeEntries == index);

        if (item) {
            // Example: Update calculations when this item changes
            item.amountNet_ColTypeEntries = item.displayQty_ColTypeEntries * item.amount_ColTypeEntries;
            if (item.recMarker !== "new")
                item.recMarker = "modified";

            // Optional: Mark as dirty for save detection
            loadedTransaction.value.isModified = true;
            loadedTransaction.value.transaction_Header.totalAmount_TransH = grandTotal;
            return item;
        } else {
            console.warn(`No item found at index ${index}`);
            return null;
        }
    }
}


const selectedBooklet = ref('');
// const handleBookletChange = (val) => {
//     //alert(val)
//     val
// }

const dateIssueFormatted = computed({
    get() {
        if (!loadedTransaction.value.transaction_Header.dateIssue_TransH) {
            const today = new Date();
            return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        }
        return loadedTransaction.value.transaction_Header.dateIssue_TransH.split('T')[0];
    },
    set(newValue) {
        loadedTransaction.value.transaction_Header.dateIssue_TransH =
            newValue ? `${newValue}T00:00:00` : null;
    }
});

const chequeDateFormatted = computed({
    get() {
        if (!loadedTransaction.value.transaction_Header.dateAccountDocument_TransH) {
            const today = new Date();
            return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        }
        return loadedTransaction.value.transaction_Header.dateAccountDocument_TransH.split('T')[0];
    },
    set(newValue) {
        loadedTransaction.value.transaction_Header.dateAccountDocument_TransH =
            newValue ? `${newValue}T00:00:00` : null;
    }
});


const shouldShow = (trans) => {
    // Most likely case first for better performance
    if (trans.recMarker === 'deleted') return false;

    // Then check other valid cases
    return !trans.recMarker || trans.recMarker === 'new' || 'existing';
}

const onItemAdded = (item) => {
    mode.value = "concessionaire";
    title.value = "Create Account";
    typedName.value = item.label;
    toggleModal();
}

const onPayorSelected = (payor) => {
    //alert(payor)
    if (payor) {
        if (payor.label !== '' && payor.label !== null) {
            loadedTransaction.value.transaction_Header.sysFK_UM_TransH = payor.value;
            loadedTransaction.value.transaction_Header.nameFull_UM_TransH = payor.label;
            loadedTransaction.value.transaction_Header.userFK_UM_TransH = payor.raw.userPK_UM;
        }
        else {
            loadedTransaction.value.transaction_Header.sysFK_UM_TransH = 0,
                loadedTransaction.value.nameFull_UM_TransH = null;
        }
    }
    else {
        loadedTransaction.value.transaction_Header.sysFK_UM_TransH = 0,
            loadedTransaction.value.nameFull_UM_TransH = null;
    }
}

function onBookletSelected(booklet) {
    selectedBooklet.value = booklet;
    if (booklet) {
        loadedTransaction.value.booklet = booklet.raw;
        loadedTransaction.value.transaction_Header.sysFK_BatchTransH_TransH = booklet.raw.sysPK_ARMLogBk;
        loadedTransaction.value.transaction_Header.sysSeq_TransH = booklet.raw.sysSeq_ARMLogBk;
        loadedTransaction.value.transaction_Header.userSeq_TransH = booklet.raw.userSeq_ARMLogBk;
        if (loadedTransaction.value.transaction_Header.recMarker === "new") {
            loadedTransaction.value.transaction_Header.userPK_TransH = getBookletNextNumber(booklet.raw);
        }
    }
}

function checkChange() {
    const bonded = employeeOptions.value.find(x => String(x.raw.sysPK_UM) === String(loadedTransaction.value.transaction_Header.sysFK_InCharge_TransH));
    if (bonded) {
        loadedTransaction.value.transaction_Header.inChargedBy_TransH = bonded.raw.reportName_UM;
    }
}
function setTransaction() {
    if (loadedTransaction.value.transaction_Header.moduleType_TransH !== 'FORM51') {
        loadedTransaction.value.transaction_Header.isInLiue = true;
    }
    else {
        loadedTransaction.value.transaction_Header.isInLiue = false;
    }
    if (loadedTransaction.value.transaction_Header.sysFK_BatchTransH_TransH)
        selectedBooklet.value = JSONbigString.stringify(loadedTransaction.value.transaction_Header.sysFK_BatchTransH_TransH)?.toString()
    if (loadedTransaction.value.transaction_Header.nameFull_UM_TransH && loadedTransaction.value.transaction_Header.nameFull_UM_TransH !== '')
        cbActRef.value.preSelectOption({
            label: loadedTransaction.value.transaction_Header.nameFull_UM_TransH, value:
                loadedTransaction.value.transaction_Header.sysFK_UM_TransH,
            raw: {
                name_UM: loadedTransaction.value.transaction_Header.nameFull_UM_TransH, sysPK_UM:
                    loadedTransaction.value.transaction_Header.sysFK_UM_TransH,
                userPK_UM: loadedTransaction.value.transaction_Header.userFK_UM_TransH
            }
        });
    // cbBondedRef.value.preSelectOption({
    //     label: loadedTransaction.value.transaction_Header.inChargedBy_TransH,
    //     value: loadedTransaction.value.transaction_Header.sysFK_InCharge_TransH,
    //     raw: {
    //         label: loadedTransaction.value.transaction_Header.inChargedBy_TransH,
    //         value: loadedTransaction.value.transaction_Header.sysFK_InCharge_TransH,
    //     }
    // });
    if (loadedTransaction.value.booklet)
        cbBooklet.value.preSelectOption({
            label: loadedTransaction.value.booklet.text,
            value: loadedTransaction.value.booklet.value,
            raw: loadedTransaction.value.booklet
        });
}
const transactionClicked = async (trans) => {
    spinnerService.show();
    selectedTab.value = "Entry";
    loadedTransaction.value = await transactionService.getInfo(String(trans.sysPK_TransH));
    setTransaction();
    spinnerService.hide();
}

function handleInlieuChange() {
    if (loadedTransaction.value.transaction_Header.isInLiue) {
        loadedTransaction.value.transaction_Header.moduleType_TransH = 'FORM51';
    }
}

const employeeOptions = ref(null);
// eslint-disable-next-line
async function getBondedCashiers(forceRefresh = false) {

    try {
        const response = await umService.getBondedCashiers(forceRefresh);
        employeeOptions.value = Array.isArray(response)
            ? response.map(x => ({
                value: JSONbig.stringify(x.sysPK_UM).toString(),
                label: x.reportName_UM,
                raw: { ...x } // Clone the object to avoid reference issues
            }))
            : []; // Fallback if response isn't an array
        // return employeeOptions.value; // Optional: Return the transformed data
    } catch (error) {
        console.error("Failed to load bonded cashiers:", error);
        employeeOptions.value = [];
        throw error; // Re-throw if you want calling code to handle it
    }
}

const STORAGE_KEY = "wbcol";
onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', saveToStorage)
    //window.removeEventListener('beforeunload', beforeUnloadHandler)
})

// 6. Storage functions
async function saveToStorage() {
    try {
        localStorage.setItem(STORAGE_KEY, JSONbigString.stringify(loadedTransaction.value))
    } catch (e) {
        console.error('Failed to save to localStorage:', e)
    }
}

function loadFromStorage() {
    try {
        const data = localStorage.getItem(STORAGE_KEY)
        if (data) {
            const tempData = JSONbigString.parse(data);
            return tempData;
        }
        return null;
    } catch (e) {
        console.error('Failed to load from localStorage:', e)
        return null
    }
}

function onConcessionaireAdded(concessionaire) {
    toggleModal();
    cbActRef.value.preSelectOption({
        label: concessionaire.text,
        value: concessionaire.value,
        raw: { ...concessionaire }
    })
}

const toggleModal = () => {
    showModal.value = !showModal.value;
}
onMounted(() => {
    getBondedCashiers();
    const savedData = loadFromStorage()
    if (savedData) {
        loadedTransaction.value = savedData;
        setTransaction();
    }
    cbItemRef?.value.preSelectOption({ label: "", value: 0 })
    window.addEventListener('beforeunload', saveToStorage)
    router.beforeEach((to, from, next) => {
        saveToStorage();
        next()
    })
})


</script>

<style scoped>
tr.bg-danger>td {
    background-color: #dc3545 !important;
}
</style>